import { SERVER } from '../environment.constants'

export class UnitURL {
    public static unit: string = SERVER + "/unit";
    public static unitList: string = UnitURL.unit + "/list"
    public static addUnit: string = UnitURL.unit + "/add"
    public static userUnit = (accountSeq: number) => `${UnitURL.unit}/${accountSeq}`;
}